import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getLeadResearchCosts from "../http/getLeadResearchCosts";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

// Landlord-research spend over a window (Stage D). Admin-only (inrange-org gated).
export const useLeadResearchCosts = (days: number, enabled = true) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);
  return useQuery(
    ["leadResearchCosts", days],
    async () =>
      getLeadResearchCosts(await getAuthTokenBlocking(getToken, relogin), days),
    { enabled }
  );
};

export default useLeadResearchCosts;
